exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".smart-home-catalog__content-item-text{display:flex;flex-direction:column;height:300px;overflow:auto}.smart-catalog__slick-arrow{z-index:10;top:calc(50% - var(--slider-arrow)/2);display:flex;flex-flow:row nowrap;justify-content:center;align-items:center;border-radius:50%;background-color:var(--c-primary);right:-25px;font-size:0;line-height:0;position:absolute;top:50%;display:block;padding:0;transform:translateY(-50%);cursor:pointer;border:none}.smart-catalog__slick-arrow_prev{left:-25px}", ""]);

// exports
